export default __webpack_public_path__ + "static/media/timesUp.0cbb5adf.mp3";